import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"

import type { Column } from "../types"

import { useAIParserSession } from "./use-ai-parser-session"
import { useEditColumnMutation } from "./use-edit-column-mutation"
import { columnSchema, type FormColumn } from "../schemas/column-schema"

export function useEditColumn(column: Column) {
  const { currentSessionId } = useAIParserSession()

  const editColumnForm = useForm<FormColumn>({
    resolver: zodResolver(columnSchema),
    defaultValues: {
      name: column.name,
      dataType: column.data_type,
      description: column.description,
      optionTypeId: column.option_type_id,
      options: column.options ?? [],
    },
  })

  const editColumnMutation = useEditColumnMutation()

  function editColumn(data: FormColumn) {
    if (!currentSessionId) {
      return
    }

    editColumnMutation.mutate({
      sessionId: currentSessionId,
      columnId: column.id,
      name: data.name,
      dataType: data.dataType,
      description: data.description,
      optionTypeId: data.dataType === "options" ? data.optionTypeId : undefined,
      options: data.dataType === "options" ? data.options : [],
    })
  }

  return {
    editColumnForm,
    editColumn,
    editColumnMutation,
  }
}
